var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header"}},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/ver2/logo.png")}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }